import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z', fill: '#E7F8F0' }),
        React.createElement(Path, { d: 'M8.075 11.825l2.45 2.45 5.35-5.35a.804.804 0 01.588-.25c.225 0 .412.083.562.25.15.15.23.333.238.55a.707.707 0 01-.213.55l-6 6a.72.72 0 01-.525.225.72.72 0 01-.525-.225l-3.05-3.05a.712.712 0 01-.25-.55.79.79 0 01.25-.575.79.79 0 01.575-.25c.217 0 .4.075.55.225z', fill: '#12B76A' })));
}
export default SvgComponent;
